import { render } from "./ModalItem.vue?vue&type=template&id=78f56d29"
import script from "./ModalItem.vue?vue&type=script&lang=js"
export * from "./ModalItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__